import { render, staticRenderFns } from "./d-text-with-links.vue?vue&type=template&id=31c3b233&scoped=true&"
import script from "./d-text-with-links.vue?vue&type=script&lang=js&"
export * from "./d-text-with-links.vue?vue&type=script&lang=js&"
import style0 from "./d-text-with-links.vue?vue&type=style&index=0&id=31c3b233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c3b233",
  null
  
)

export default component.exports